import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'

export const QuestionWrapper = styled.div`
  color: ${props => props.theme.palette.primary.alphaDark};
  text-align: center;
  min-height: 55vh;
  ${bp('sm')`
    margin-bottom: 25px;
  `}

  h3 {
    font: ${font('default', 'medium', '35px/1.5')};
    margin: 0;
    ${bp('sm')`
      font: ${font('default', 'medium', '25px/1.2')};
    `}
  }

  .question {
    &__heading {
      margin-bottom: 25px;
    }

    &__info {
      font: ${font('default', 'normal', '18px/1.2')};
      font-style: oblique;
      ${bp('sm')`
        font: ${font('default', 'normal', '16px/1')};
      `}
    }
  }
`

export const HeaderWrapper = styled.div`
  div {
    background: ${props => props.theme.palette.primary.beta};
    padding: 15px 30px;
    text-align: center;
    color: ${props => props.theme.palette.general.light};
    font-weight: bold;

    p {
      padding: 5px 40px;
      line-height: 25px;
      ${bp('sm')`
        padding: 5px 10px;
      `}
    }

    h1 {
      font: ${font('default', 'bold', '48px/1')};
      text-transform: uppercase;
    }
  }
`

export const NoQuestions = styled.h1`
  text-align: center;
  line-height: 1.5;
  padding: 20px 0 30px;
`
